import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "EDU_SUB_RATIO_PROJECTED",
  title: defineMessage({
    id: "fig.finance.aid.EDU_SUB.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.EDU_SUB.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.EDU_SUB.source",
    defaultMessage: ``,
  }),
};
